import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useMemo } from 'react'
import Box from 'src/components/Box/Box'
import Trns from 'src/localization/Trns'
import { VirtualCardListModel } from 'src/models/virtualCard.models'
import {
  AutomationRuleListSortField,
  useAutomationRuleList,
} from 'src/queries/organizations/automationRules.queries'
import { css } from 'styled-components'

interface VirtualCardExpenseCategoriesBoxProps {
  virtualCard: VirtualCardListModel
}

const LabelAndValue: React.FC<{
  category: string
  label: string
}> = (props): React.ReactElement => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;

        &:nth-child(n + 2) {
          margin-top: 30px;
        }
      `}
    >
      <span
        css={css`
          ${getFontCss(
            12,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )}
        `}
      >
        {props.category}
      </span>
      <span
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )}
        `}
      >
        {props.label}
      </span>
    </div>
  )
}

const ExpenseCategoriesReadOnlyBox: React.FC<
  VirtualCardExpenseCategoriesBoxProps
> = (props): React.ReactElement => {
  const { data: virtualCardRules } = useAutomationRuleList({
    filters: {
      sortField: AutomationRuleListSortField.CreatedAt,
      sortDirection: 'DESC',
      fundingSourceIds: [props.virtualCard?.id ?? ''],
    },
    enabled: props.virtualCard?.id !== undefined,
  })
  // TODO: currently assuming only one rule per VCN
  const virtualCardRule = useMemo(
    () => virtualCardRules?.[0],
    [virtualCardRules],
  )

  return (
    <Box
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          margin-bottom: 40px;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )}
          `}
        >
          <Trns source={'Expense Categories'} />
        </span>
      </div>
      <div>
        {virtualCardRule?.mappings?.map((extDetail, i) => (
          <LabelAndValue
            key={i + 2}
            category={extDetail.expenseCategory.name}
            label={extDetail.expenseLabel?.name || '--'}
          />
        ))}
      </div>
    </Box>
  )
}

export default React.memo(ExpenseCategoriesReadOnlyBox)
